import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from "@ngx-translate/core";
import { IconService } from 'app/rest/icon.service';
import NotificationReceiver = Rest_task.NotificationReceiver;
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';

@Component({
    selector: 'app-map-location-picker',
    templateUrl: './map-location-picker.component.html',
    styleUrls: ['./map-location-picker.component.css'],
    providers: [ConfirmationService, IconService],
})
export class MapLocationPickerComponent implements OnInit {
    
    //title = "Configuración Avanzada";
    display = false;
    @Output() openModal = new EventEmitter<void>();

    constructor(
        private translate: TranslateService,
    ) {

    }
    ngOnInit() {
    
    }

  // Método para emitir el evento
    triggerModal() {
        this.openModal.emit();
    }

    public show(){
        this.display = true;
    }

     public hide(){
        this.display = false;
        this.triggerModal();
    }

}
